import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Label } from 'reactstrap';
import SinglePicker from '../../common/controls/singlePicker';
import NumberInput from '../../common/controls/numberInput';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import Icon from '../../common/containers/icon';
const ContractSpecSaltTestItem = props => {
  const {
    onRemove,
    onChange,
    index,
    active,
    active: {
      saltTypeID,
      testMin,
      testMax,
      saltUnitID,
      saltTestTypeID
    },
    saltTypeList,
    saltTestTypeList,
    saltUnitList
  } = props;
  const handleChangeSaltTestTypeID = value => onChange(index, 'saltTestTypeID', value);
  const handleChangeSaltTypeID = value => onChange(index, 'saltTypeID', value);
  const handleChangeSaltUnitID = value => onChange(index, 'saltUnitID', value);
  const handleChangeTestMin = value => onChange(index, 'testMin', value);
  const handleChangeTestMax = value => onChange(index, 'testMax', value);
  const confirmOnRemoveFields = ['saltTestTypeID', 'testMin', 'testMax', 'saltUnitID'];
  const handleRemove = () => onRemove(index);

  // this calls onRemove IFF either
  //   a) there is no data to confirm removing in the item, or
  //   b) the user says it is okay to remove the all the data.
  const confirmRemove = () => removeItemWithConfirm(active, 'salt test', confirmOnRemoveFields, handleRemove);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    disabled: true,
    label: "Test Performed",
    onChange: handleChangeSaltTypeID,
    options: saltTypeList,
    placeholder: "Select...",
    returnValueKey: "id",
    value: saltTypeID
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Type",
    onChange: handleChangeSaltTestTypeID,
    options: saltTestTypeList,
    placeholder: "Select...",
    returnValueKey: "id",
    value: saltTestTypeID
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    name: "saltTestButton",
    size: "sm",
    className: "form-control t-cs-sst-remove-salt-test tqc-control",
    onClick: confirmRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Test"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(Label, null, "Test"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: testMin,
    entity: "ContractSpecSaltRange",
    field: "testMin",
    onChange: handleChangeTestMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: testMax,
    entity: "ContractSpecSaltRange",
    field: "testMax",
    onChange: handleChangeTestMax
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Unit of Measure",
    onChange: handleChangeSaltUnitID,
    options: saltUnitList,
    placeholder: "Select...",
    returnValueKey: "id",
    value: saltUnitID
  }))));
};
ContractSpecSaltTestItem.propTypes = {
  index: PropTypes.number.isRequired,
  active: PropTypes.shape({
    saltTypeID: PropTypes.string,
    saltUnitID: PropTypes.string,
    testMax: PropTypes.number,
    testMin: PropTypes.number,
    saltTestTypeID: PropTypes.string
  }).isRequired,
  saltTestTypeList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  saltTypeList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  saltUnitList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default ContractSpecSaltTestItem;